<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn"></div>-->
    <div id="contentDiv">
      <div class="head_title">
        <div class="head_title_font">师资库&gt;</div>
      </div>
      <div class="body_content">
        <div class="settingMenu">
          <router-link v-for="(settingMenu, index) in setting_menu" :key="index" :to="{name: settingMenu.routeName}">
            <button type="button" class="btn btn-default settingOptionMenu"
                    :class="{click_settingOptionMenu: settingMenu.url == current_setting_menu}"
                    @click="current_setting_menu = settingMenu.url">
              {{settingMenu.name}}
            </button>
          </router-link>
        </div>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
  import {getContentSize} from './mainView';

  export default {
    name: "setting",
    data() {
      return {
        current_setting_menu : '',
        setting_menu : [
          {'routeName': 'TeacherManage','url':'/teacherManage','name':'校内教师'},
          //{'routeName': 'SuggestionsTSetting','url':'/suggestionsSetting','name':'干部教学培训质量评估'},
          //{'routeName': 'QuestionnaireSetting','url':'/questionnaireSetting','name':'干部培训课程质量评估标准'},
          {'routeName': 'TeacherManageOutside','url':'/teacherManageOutside','name':'外聘教师'},
        ],
      }
    },
    filters: {

    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        this_.current_setting_menu = this_.$route.path;
      });
    },
    methods: {

    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  @import "../assets/css/setting.css";
</style>



// WEBPACK FOOTER //
// src/components/teacherManageParent.vue